import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DialogMode } from 'src/app/components/_campanias/types/enum';
import { TwSolicitudCamViewModelBase } from 'src/app/components/_campanias/types/solicitudcam-datosbasicos.types';
import { DialogComponent } from 'src/app/components/core/components/dialog/dialog.component';
import { EmpresaDeshidratadoraItemViewModel } from '../empresadeshidratadora.types';

@Component({
    selector: 'app-empresadeshidratadora-list-dialog',
    templateUrl: './empresadeshidratadora-list-dialog.component.html',
    styleUrls: ['./empresadeshidratadora-list-dialog.component.scss'],
})
export class EmpresadeshidratadoraListDialogComponent implements OnChanges {
    @Input() visible = false;
    @Input() dialogFilter: TwSolicitudCamViewModelBase;
    @Output() selectedEmpresas = new EventEmitter<EmpresaDeshidratadoraItemViewModel[]>();

    @ViewChild(DialogComponent) private dialogComponent: DialogComponent;
    dialogMode = DialogMode.Dialog;
    preSelection: EmpresaDeshidratadoraItemViewModel[];
    dialogTitle = 'Selección de Empresas Deshidratadoras';

    constructor() {
        //
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.visible?.currentValue !== null) {
            this.visible = changes?.visible?.currentValue;
            if (this.visible) {
                this.openDialog();
            } else {
                this.closeDialog();
            }
        }
    }

    /**
     * When the user clicks in the button for adding a "Empresa Deshidratadora"
     */
    private openDialog(): void {
        // Doing this we avoid the app-empresadeshidratadora-wrapper to be initiated in first place
        setTimeout(() => {
            // To give time so the dialog is initialized
            this.dialogComponent?.showDialog();
        });
    }

    private closeDialog(): void {
        setTimeout(() => {
            // To give time so the dialog is closed
            this.dialogComponent?.closeDialog();
        });
    }

    /**
     * When the user selects "Aceptar" in the dialog, 'accepted' will be true
     * If the user clicks "Cancelar", 'accepted' will be false, in this case the preselection is discarded.
     * @param accepted boolean
     */
    onDialogAccepted(accepted: boolean): void {
        if (!accepted) {
            this.preSelection = [];
            // return;
        }

        this.selectedEmpresas.emit(this.preSelection);
    }

    /**
     * When the dialog is opened, a component is injected on it and once data is selected
     * an event is emitted.
     * dblclick equals true: The event is captured and the values are assigned to the form. This event occurs when the user double-click a row in the table-list. The dialog is automatically closed.
     * dblclick equals false: The event is captured and the values are assigned to the preselection. This event occurs when the users clicks a row in the table-list. In this case the dialog must be explicitly closed by the user.
     * @param $event Object {
     *  selection EmpresaDeshidratadoraItemViewModel[] Elements selected in the component embedded in the dialog
     *  dblclick: boolean It indicates if the user has click the row or double-clicked.
     * }
     */
    onSelectedEmpresas($event: any): void {
        const selection = $event.selection;
        const dblclick = $event.dblclick;

        if (!dblclick) {
            // In this case the dialog must be explicitly closed by the user.
            this.preSelection = selection;
            return;
        }
    }
}
